import { KdsSelect, SelectOption } from "@kazaar-platform/design-system";
import { useAtom } from "jotai";
import { useEffect } from "react";
import { type MeReadDtoLangEnum } from "@/config/apiClient";
import {
  AVAILABLE_LANGS_OPTIONS,
  DEFAULT_LANG,
  FLAG_COMPONENTS,
  LANG_DISPLAY_NAMES,
} from "@/constants/languages.constants";
import { isSupportedLang } from "@/helpers/validators/isSupportedLang";
import { tolgee } from "@/providers/TranslationProvider";
import { authLanguageAtom } from "@/store";

const FlagIcon = ({ lang }: { lang: MeReadDtoLangEnum }) => {
  const Flag = FLAG_COMPONENTS[lang];
  return <Flag className="h-4 w-6 rounded-sm" />;
};

export const LanguageSelect = () => {
  const [currentLang, setCurrentLang] = useAtom(authLanguageAtom);

  // Sync tolgee with atom value
  useEffect(() => {
    if (tolgee.getLanguage() !== currentLang) {
      void tolgee.changeLanguage(currentLang);
    }
  }, [currentLang]);

  const handleChangeLanguage = (newLang: MeReadDtoLangEnum) => {
    setCurrentLang(newLang);
    void tolgee.changeLanguage(newLang);
  };

  return (
    <KdsSelect
      size="medium"
      aria-label="Select language"
      value={currentLang}
      onChange={(key) => {
        const langValue = key?.toString();
        if (isSupportedLang(langValue)) {
          handleChangeLanguage(langValue);
        } else {
          handleChangeLanguage(DEFAULT_LANG);
        }
      }}
    >
      {AVAILABLE_LANGS_OPTIONS.map((lang) => (
        <SelectOption key={lang} id={lang} textValue={LANG_DISPLAY_NAMES[lang]}>
          <div className="flex items-center gap-sp-xs">
            <FlagIcon lang={lang} />
            <span>{LANG_DISPLAY_NAMES[lang]}</span>
          </div>
        </SelectOption>
      ))}
    </KdsSelect>
  );
};
